export const LogoMark = ({ className = "h-8 w-8", color = "#E5C158" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <path d="M9 33V17a11 11 0 0 1 22 0v16" fill="none" stroke={color} strokeWidth="2" />
    <rect x="13.5" y="21" width="3" height="12" fill={color} />
    <rect x="18.5" y="16" width="3" height="17" fill={color} />
    <rect x="23.5" y="23" width="3" height="10" fill={color} />
    <path d="M6 33h28" stroke={color} strokeWidth="2" />
  </svg>
);

export const Wordmark = () => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-9 w-9 transition-transform duration-500 group-hover:-translate-y-0.5" />
    <span className="leading-none">
      <span className="font-display block text-xl tracking-wide text-slate-50">Rinda Marbun</span>
      <span className="font-mono block text-[10px] uppercase tracking-[0.3em] text-amber-200/70 mt-1">The Legacy Shelf</span>
    </span>
  </span>
);
